// extracted by mini-css-extract-plugin
module.exports = {"icon":"EditorIcon_icon__vvOQ2"};